module.exports = __webpack_public_path__ + "img/icon-info.b2365160.svg";